<div class="p-10">
  <h2 class="text-3xl text-primary pb-12">Versorgungsanfragen</h2>
  <div class="container mx-auto p-4">
    <app-provisions-list></app-provisions-list>
  </div>
</div>
